import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import Pending from "./Pending";

const PendingCounselorLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Pending Counselors" />
      <Pending />
    </MasterLayout>
  );
};

export default PendingCounselorLayout;
